import {
  API_REQUEST,
  API_SUCCESS,
  SET_ERROR,
  VTR_TRIP_DATA_REQUEST,
} from "./actionTypes";

export const vtrRequest = ({
  url,
  method,
  client_id,
  token,
  user_app_status,
  trip_id,
}) => {
  if (!url) {
    console.error("vtrRequest", "no URL provided");
    return {
      type: SET_ERROR,
      error: "no URL provided",
    };
  }
  if (!method) {
    console.error("vtrRequest", "no method provided");
    return {
      type: SET_ERROR,
      error: "no method provided",
    };
  }
  if (!client_id) {
    console.error("vtrRequest", "no client_id provided");
    return {
      type: SET_ERROR,
      error: "no client_id provided",
    };
  }
  if (!token) {
    console.error("vtrRequest", "no token provided");
    return {
      type: SET_ERROR,
      error: "no token provided",
    };
  }
  if (!trip_id) {
    console.error("vtrRequest", "no trip_id provided");
    return {
      type: SET_ERROR,
      error: "no trip_id provided",
    };
  }
  return {
    type: VTR_TRIP_DATA_REQUEST,
    meta: {
      api_request_url: url,
      api_request_method: method,
      client_id,
      token,
      user_app_status,
      trip_id,
    },
  };
};

// action creators
export const apiRequest = ({ url, method, data, username, password }) => {
  return {
    type: API_REQUEST,
    meta: {
      api_request_url: url,
      api_request_method: method,
      api_request_data: data,
      username,
      password,
    },
  };
};

export const apiSuccess = ({ response }) => {
  return {
    type: API_SUCCESS,
    payload: response,
  };
};
